// extracted by mini-css-extract-plugin
module.exports = {"root":"OptionContent_root__2ro5b","accent":"OptionContent_accent__33ygp"};